import React from 'react'

import FastDelivery from '../../assets/images/icons/30MinDelivery.svg';
import TimeIsMoney from '../../assets/images/icons/TimeIsMoney.svg';
import Youtuber from '../../assets/images/icons/youtuber.svg';
import Discount from '../../assets/images/icons/discount.svg';
import Accuracy from '../../assets/images/icons/Accuracy.svg';

const Feature = () => {
  return (
    <div className='container feature-container flex py-2 pt-md-3' x-intersect="$el.classList.add('fadeInUp-parallax')">
          <FeatureItem icon={Accuracy} bgColor="#E4FAFF" text="High accuracy intent prediction" cls="accuracy"/>
          <FeatureItem icon={Discount} bgColor="#E4FAFF" text="Automated personalized nudges (offers)" cls="discount"/>
          <FeatureItem icon={TimeIsMoney} bgColor="#E4FAFF" text="Boosts conversion by 45% on average" cls="time_is_money"/>
          <FeatureItem icon={FastDelivery} bgColor="#E4FAFF" text="Works in real-time to convert visitors" cls="fastDelivery"/>
          <FeatureItem icon={Youtuber} bgColor="#E4FAFF" text="Tested with 200 million+ sessions" cls="youtuber"/>
    </div>
  )
}

export default Feature

export const FeatureItem = (props) => {
    const { icon, bgColor:bg, text, cls} = props
    return (
        <div className='feature-item-container flex me-4' x-intersect="$el.classList.add('feature-parallax')">
          <div className={`featureIcon-container me-2`}  style={{backgroundColor:bg}}>
            <img src={icon} alt="icon"/>
          </div>
          <div className='feature-details'>
            <p >{text}</p>
          </div>
        </div>
    )
}


